import select from 'dom-select';
import windowIsLargerThan from '@lib/measureViewport';

// eslint-disable
export const openNavigation = new Event('openNavigation');
export const closeNavigation = new Event('closeNavigation');
// eslint-enable

function GlobalHeader(el) {
  const ui = {
    el,
    navigation: select('.global-header__navigation', el),
    menuToggle: select('.global-header__menu-button', el),
    loginButton: select('.global-header__login', el),
    logo: select('.global-header__brand', el),
    navHeadings: select.all('.global-header__nav-heading', el),
    navItems: select.all('.global-header__nav-link', el),
    navMenuLabel: select('.global-header__menu-label', el)
  };

  const state = {
    isMobile: null,
    navOpen: false,
    throttle: false
  };

  const options = {
    // breakpoint : rems * 16px
    breakpoint: (40 * 16)
  };

  function throttle(func, limit, ...args) {
    const context = this;

    if (state.throttle === false) {
      func.apply(context, args);
      state.throttle = true;
      setTimeout(() => { state.throttle = false; }, limit);
    }
  }

  function moveToDesktopSettings() {
    state.isMobile = false;

    ui.logo.setAttribute('tabIndex', 1);
    ui.menuToggle.setAttribute('tabIndex', 2);
    ui.loginButton.setAttribute('tabIndex', 3);
  }

  function moveToMobileSettings() {
    state.isMobile = true;

    ui.logo.removeAttribute('tabIndex');
    ui.loginButton.removeAttribute('tabIndex');
    ui.menuToggle.removeAttribute('tabIndex');
  }

  function handleBreakpointChange() {
    if (windowIsLargerThan(options.breakpoint) && state.isMobile) {
      moveToDesktopSettings();
    } else if (!windowIsLargerThan(options.breakpoint) && !state.isMobile) {
      moveToMobileSettings();
    }
  }

  function handleScreenSizeChange() {
    if (state.isMobile !== !windowIsLargerThan(options.breakpoint)) {
      throttle(handleBreakpointChange, 200);
    }
  }

  function bindEvents() {
    ui.el.addEventListener('openNavigation', () => {
      ui.el.classList.add('nav-open');
      ui.menuToggle.setAttribute('aria-expanded', true);
      state.navOpen = true;
      ui.navMenuLabel.innerHTML = 'Close';
    });

    ui.el.addEventListener('closeNavigation', () => {
      ui.el.classList.remove('nav-open');
      ui.menuToggle.setAttribute('aria-expanded', false);
      state.navOpen = false;
      ui.navMenuLabel.innerHTML = 'Menu';
    });

    ui.menuToggle.addEventListener('click', () => {
      if (!state.navOpen) {
        ui.el.dispatchEvent(openNavigation);
      } else {
        ui.el.dispatchEvent(closeNavigation);
      }
    });

    ui.navItems.forEach((link) => {
      link.addEventListener('keydown', (ev) => {
        const { keyCode } = ev;

        if (keyCode === 27) {
          ui.menuToggle.focus();
        }
      });
    });

    window.addEventListener('resize', () => handleScreenSizeChange());
  }

  function handleAria() {

    if (!state.isMobile) {
      ui.navHeadings.forEach((button) => {
        button.setAttribute('tagName', 'button');
        button.setAttribute('aria-expanded', false);
      });

      ui.navItems.forEach((link) => {
        // link.setAttribute('tabIndex', -1);
        link.setAttribute('aria-hidden', true);
      });
    }
  }

  function init() {
    if (windowIsLargerThan(options.breakpoint)) {
      state.isMobile = false;
      moveToDesktopSettings();
    } else {
      state.isMobile = true;
      moveToDesktopSettings();
    }

    handleAria();
    bindEvents();
  }

  init();
}

export default GlobalHeader;
